<template>
  <div class="">
    <div>
      <img src="../assets/contact_banner.png" alt="">
    </div>
    <div class="container connect">
      <!-- <div id="map">

      </div> -->
      <p class="address">
        公司地址： 北京市朝阳区安翔北路11号北京创业大厦B座6层
        <span>
        </span>
      </p>
      <p class="youbian">
        邮政编码： 100101
      </p>
      <p class="phone">
        联系电话： 010-86466671
      </p>
      <p class="mail">
        业务咨询： diaoshd@yoxnet.com 刁经理
      </p>
      <p class="hr">
        投递简历： hr@yoxnet.com
      </p>
    </div>
    <Footer/>
  </div>
</template>

<script>
  import Footer from '../components/Footer'

  export default {
    name: 'Introduction',
    mounted() {
      // 百度地图API功能
      // var BMap = window.BMap
      // var map = new BMap.Map('map', {enableMapClick: false});
      // var poi = new BMap.Point(116.384084, 39.999624);
      // map.centerAndZoom(poi, 16);
      // map.enableScrollWheelZoom();

      // var content = '<div style="margin:0;line-height:20px;padding:2px;">' +
      //   '<img src="../img/baidu.jpg" alt="" style="float:right;zoom:1;overflow:hidden;width:100px;height:100px;margin-left:3px;"/>' +
      //   '<br/>地址：北京市朝阳区安翔北路11号北京创业大厦B座6层<br/> <br/>电话： 010-86466671<br/> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
      //   '</div>';

      // //创建检索信息窗口对象
      // var searchInfoWindow = null;
      // searchInfoWindow = new window.BMapLib.SearchInfoWindow(map, content, {
      //   title: "北京悦享互联技术有限公司",      //标题
      //   width: 300,             //宽度
      //   height: 105,              //高度
      //   panel: "panel",         //检索结果面板
      //   enableAutoPan: true,     //自动平移
      //   searchTypes: []
      // });
      // var marker = new BMap.Marker(poi); //创建marker对象
      // marker.addEventListener("click", function () {
      //   searchInfoWindow.open(marker);
      // })
      // map.addOverlay(marker); //在地图中添加marker
      // searchInfoWindow.open(marker);
    },
    components: {
      Footer
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  img {
    width: 100%;
  }

  #map {
    height: 400px;
    margin-bottom: 7rem;
  }

  .connect {
    margin-top: 4rem;
  }

  .connect p {
    font-size: 1.8rem;
    color: #666;
    line-height: 30px;
    padding-left: 70px;
    margin-bottom: 30px;
  }
  .connect p span {
    display: block;
    text-align: center;
    color: #999;
  }
  .address {
    background: url("../assets/contact_address_icon01.png") no-repeat left top;
  }
  .youbian {
    background: url("../assets/contact_Zipcode_icon02.png") no-repeat left top;
  }
  .phone {
    background: url("../assets/contact_phone_icon03.png") no-repeat left top;
  }
  .mail {
    background: url("../assets/contact_advisory_icon04.png") no-repeat left top;
  }
  .hr {
    background: url("../assets/contact_advisory_icon05.png") no-repeat left top;
  }

</style>
